export default "__VITE_ASSET__aCDfwizw__"